/*
 * @Author: 317473294@qq.com
 * @Date: 2023-05-24 10:27:20
 * @LastEditTime: 2023-10-22 14:40:04
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/api/role.js
 */
//导入请求拦截与响应拦截，每次请求，都会经过请求拦截，请求结束会产生响应拦截，
import Axios from "../axios"

//获取菜单
export function getRole(data){
    console.log(data)
    return Axios({
        method:"get",
        url:"/api/getRole",
        data:data
    })
}
//添加菜单
export function addRole(data){
    console.log(data)
    return Axios({
        method:"put",
        url:"/api/addRole",
        data:data
    })
}

//更新菜单
export function updataRole(data){
    return Axios({
        method:"patch",
        url:"/api/updataRole",
        data:data
    })
}
//删除菜单
export function deleteRole(data){
    return Axios({
        method:"delete",
        url:"/api/deleteRole",
        data:data
    })
}
//模糊查询角色
export function vogueSearchRole(data){
    return Axios({
        method:"post",
        url:"/api/vogueSearchRole",
        data:data
    })
}
//查询菜单api/getRoleMenu
export function getRoleMenuIds(data){
    return Axios({
        method:"post",
        url:"/api/getRoleMenuIds",
        data:data
    })
}




// WEBPACK FOOTER //
// ./src/api/role.js